<div class="p-[30px] text-center flex flex-col justify-center items-center h-full w-full">
    <div class="font-montserrat text-[20px] text-center">Would you like to set up two factor authentication?</div>
    <p class="font-montserrat my-8 text-current">
        Setting up 2FA is a great way to protect your account. When set up, a code from your phone will be required to log in, in addition to your password.
    </p>
    <div class="flex gap-4 font-montserrat">
        <button class="rounded-[10px] bg-red-primary hover:bg-red-secondary text-red-secondary hover:text-red-primary w-[100px] h-[51px] m-auto" [mat-dialog-close]="false">No</button>
        <button class="rounded-[10px] bg-green-primary hover:bg-green-secondary text-green-secondary hover:text-green-primary w-[100px] h-[51px] m-auto" [mat-dialog-close]="true">Yes</button>
    </div>
</div>